// store/index.js
import { createStore } from 'vuex';

const store = createStore({
    state() {
        return {
            matchId: JSON.parse(localStorage.getItem('matchId')) || null, //赛事id
            matchTitle: JSON.parse(localStorage.getItem('matchTitle')) || null, //赛事名称
            matchStatus: JSON.parse(localStorage.getItem('matchStatus')) || null, //赛事状态
        };
    },
    mutations: {
        setMatchId(state, matchId) {
            state.matchId = matchId;
            localStorage.setItem('matchId', JSON.stringify(matchId)); // 保存到 localStorage
        },
        setMatchStatus(state, matchStatus) {
            state.matchStatus = matchStatus;
            localStorage.setItem('matchStatus', JSON.stringify(matchStatus)); // 保存到 localStorage
        },
        clearMatchId(state) {
            state.matchId = null;
            localStorage.removeItem('matchId'); // 从 localStorage 中移除
        },
        setMatchTitle(state, matchTitle) {
            state.matchTitle = matchTitle;
            localStorage.setItem('matchTitle', JSON.stringify(matchTitle)); // 保存到 localStorage
        },
        clearMatchTitle(state) {
            state.matchTitle = null;
            localStorage.removeItem('matchTitle'); // 从 localStorage 中移除
        },
        clearMatchStatus(state) {
            state.setMatchStatus = null;
            localStorage.removeItem('setMatchStatus'); // 从 localStorage 中移除
        },
    },
    actions: {
        fetchMatchId({ commit }, matchId) {
            // 这里可以进行异步操作，比如从 API 获取用户数据
            commit('setMatchId', matchId);
        },
        fetchMatchTitle({ commit }, matchTitle) {
            // 这里可以进行异步操作，比如从 API 获取用户数据
            commit('setMatchTitle', matchTitle);
        },
        fetchMatchStatus({ commit }, matchStatus) {
            // 这里可以进行异步操作，比如从 API 获取用户数据
            commit('setMatchStatus', matchStatus);
        },
    },
    getters: {
        getMatchId(state) {
            return state.matchId;
        },
        getMatchTitle(state) {
            return state.matchTitle;
        },
        getMatchStatus(state) {
            return state.matchStatus;
        },
    },
    modules: {}
});

export default store;
